import './NotificationEmptyState.scss';

import React from 'react';
import Loader from '../../components/loader';
import { NotificationsEmptyStateIcon } from '../../icons/icons';
import { NotificationData } from '../notifications-types';

export type NotificationsEmptyStateProps = {
  isLoading: boolean;
  filteredNotifications: NotificationData[];
};

export default function NotificationsEmptyState({ isLoading, filteredNotifications }: NotificationsEmptyStateProps) {
  if (filteredNotifications.length > 0) {
    return null;
  }

  return (
    <div className="notification-empty-state">
      {isLoading ? (
        <Loader isLoading />
      ) : (
        <>
          <NotificationsEmptyStateIcon />
          <div className="empty-state-message">You're all caught up</div>
        </>
      )}
    </div>
  );
}
